import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData } from '@next/core-lib/dialog';

interface ImportDialogOutputModel {
  file1: File;
  file2: File;
  calendarYear: number;
}

@Component({
  selector: 'app-import-phosphate-legal-norm',
  templateUrl: './import-phosphate-legal-norm.component.html',
  standalone: false,
})
export class ImportPhosphateLegalNormComponent extends AbstractDialog<ImportDialogOutputModel> {
  data = inject<AbstractDialogData>(MAT_DIALOG_DATA);
  protected mdDialogRef = inject<MatDialogRef<ImportPhosphateLegalNormComponent, AbstractDialogResultData<ImportDialogOutputModel>>>(MatDialogRef);

  @ViewChild('file1', { static: true }) inputFile1: ElementRef<HTMLInputElement>;
  @ViewChild('file2', { static: true }) inputFile2: ElementRef<HTMLInputElement>;
  selectedFile1: File;
  selectedFile2: File;
  years = Array.from({ length: new Date().getFullYear() + 2 - 2020 }, (_, k) => k + 2020);
  formGroup = new FormBuilder().group({
    yearControl: [new Date().getFullYear(), [Validators.required]],
  });

  onFileSelected(nth: number) {
    if (nth === 1) {
      this.selectedFile1 = this.inputFile1.nativeElement.files[0];
    } else {
      this.selectedFile2 = this.inputFile2.nativeElement.files[0];
    }
  }
}
